/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  ActionIcon,
  DetailStack,
  HStack, ICON_LINK, ICON_PENCIL_OUTLINE, SimpleTable,
} from '@doveit/bricks';
import { HRInterview, JobApplication } from '../../../providers/api/dtos';
import ViewHRInterviewPopoverPreview from '../view-hr-interview-popover-preview/ViewHRInterviewPopoverPreview';
import HRInterviewAvatar from '../../components/hr-interview-avatar/HRInterviewAvatar';
import DateViewer from '../../../components/date-viewer/DateViewer';
import UpdateHRInterviewStatus from '../update-hr-interview-status/UpdateHRInterviewStatus';
import UpsertHRInterviewAction from '../../../job-application/containers/upsert-hr-interview-action/UpsertHRInterviewAction';
import TextPreview from '../../../components/text-preview/TextPreview';
import ViewHRInterviewParticipantsPreview from '../view-hr-interview-participants-preview/ViewHRInterviewParticipantsPreview';

export interface ViewHRInterviewTableRowProps extends React.AriaAttributes {
  hrInterview: HRInterview,
  jobApplication: JobApplication,
  canUpdate?: boolean,
  onUpdate?: (hrInterview: HRInterview) => void,
}

const ViewHRInterviewTableRow: React.FC<ViewHRInterviewTableRowProps> = ({
  hrInterview,
  jobApplication,
  canUpdate = false,
  onUpdate,
  ...rest
}) => (
  <SimpleTable.Row
    aria-label="Informazioni colloquio"
    {...rest}
  >
    <SimpleTable.Cell
      aria-label="Preview"
      width="10rem"
    >
      <ViewHRInterviewPopoverPreview
        hrInterview={hrInterview}
        applicationType={jobApplication.applicationType}
        applicantId={jobApplication.applicantId}
        trigger={(
          <HStack gap={100} wrap="nowrap">
            <HRInterviewAvatar size="S" />
            <DetailStack label={hrInterview.isRemote ? 'Colloquio da remoto' : 'Colloquio in presenza'}>
              <DateViewer
                stringDate={hrInterview.date}
                checkIfToday
                checkIfTomorrow
                withStrong
                withHour
              />
            </DetailStack>
          </HStack>
        )}
      />
    </SimpleTable.Cell>

    <SimpleTable.Cell aria-label="Stato">
      <UpdateHRInterviewStatus
        hrInterview={hrInterview}
        onSuccess={onUpdate}
        showAsBadge={!canUpdate}
      />
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Partecipanti"
    >
      <ViewHRInterviewParticipantsPreview
        hrInterview={hrInterview}
        jobApplication={jobApplication}
      />
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Note"
    >
      {hrInterview.note && (
        <TextPreview text={hrInterview.note} />
      )}
    </SimpleTable.Cell>

    <SimpleTable.Cell
      aria-label="Azioni"
      align="right"
    >
      <HStack gap={75} wrap="nowrap">
        <UpsertHRInterviewAction
          jobApplication={jobApplication}
          hrInterview={hrInterview}
          canUpdate={canUpdate}
          onSuccess={onUpdate}
        >
          {({ isSaving, openModal }) => (
            <ActionIcon
              aria-label="Modifica colloquio"
              label="Modifica"
              size="S"
              icon={{ path: ICON_PENCIL_OUTLINE }}
              onClick={openModal}
              loading={isSaving}
            />
          )}
        </UpsertHRInterviewAction>

        {hrInterview.isRemote && (
          <ActionIcon
            aria-label="Vai alla pagina del meet"
            label="Meet"
            size="S"
            icon={{ path: ICON_LINK }}
            href={hrInterview.meetingLink}
            target="_blank"
          />
        )}
      </HStack>
    </SimpleTable.Cell>
  </SimpleTable.Row>
);

export default ViewHRInterviewTableRow;
